import { parsePhoneNumberFromString } from "libphonenumber-js";

export function getCountryCodeFromNumber(phoneNumber: string) {
  try {
    const parsedNumber = parsePhoneNumberFromString(`+${phoneNumber}`);
    if (!parsedNumber) return null;

    return {
      countryCode: parsedNumber.country, 
      countryCallingCode: parsedNumber.countryCallingCode,
    };
      } catch (error) {
    return null;
  }
}